module.exports = __webpack_public_path__ + "img/9788985635936.d9fb0401.jpg";